RivalIQ.apps.Dashboard.module('widgets', function (widgets, App, Backbone, Marionette, $, _, s, sprintf) {

    'use strict';

    const MetricPercentageView = RivalIQ.views.LayoutView.mixin({
        template: '#widgetMetricPercentageTemplate',
        className: 'metric-summary',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            'charts': '.x-chart-region'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        behaviors: function () {
            const me = this;
            const metric = me.dashboardModel.metric;
            const information = metric.getInformation();

            return {
                Titles: RivalIQ.behaviors.Titles,
                Information: {
                    behaviorClass: RivalIQ.behaviors.Information,
                    information: information
                }
            };
        },

        loadData: function () {
            const me = this;
            const metricDefinition = me.dashboardModel.metric;
            const submetric = me.dashboardModel.submetric;
            const divisor = me.dashboardModel.divisor;
            const metrics = [metricDefinition];

            if (submetric) {
                metrics.push(submetric);
            }
            if (divisor) {
                metrics.push(divisor);
            }

            const collection = new RivalIQ.collections.MetricDefinitions(metrics);

            return collection.fetch()
                .done(function (collection) {
                    me.model = collection.first();
                    if (submetric) {
                        me.submetric = collection.at(1);
                    }
                    if (divisor) {
                        me.divisor = collection.last();
                    }
                });
        },

        serializeData: function () {
            const me = this;

            const data = {
                metric: {
                    name: me.dashboardModel.getTitle() || me.model.getName(),
                    value: me.dashboardModel.getDisplayValue(me.model, me.divisor),
                    unabbreviatedValue: me.dashboardModel.getDisplayValue(me.model, me.divisor)
                },
                submetric: null,
                hideMetric: Boolean(me.dashboardModel.hideMetric)
            };

            if (me.submetric) {
                data.submetric = {
                    name: me.submetric.getName(),
                    value: me.submetric.getValue()
                };
            }

            return data;
        },

        onRender: function () {
            const me = this;

            me.showBarCharts();
            me.$('[data-toggle="popover"]').popover();
        },

        getChartData: function () {
            const me = this;

            const percentWidth = me.dashboardModel.getPercentWidth(me.model, me.divisor);
            const quotient = me.model.getValue();
            const divisor = me.divisor.getValue();

            const titleTemplate = me.dashboardModel.barTitle || '%s / %s';
            const title = sprintf(titleTemplate, quotient, divisor);
            const information = me.dashboardModel.barTitleInfo;

            return {
                title: title,
                percentWidth: percentWidth,
                value: quotient,
                showValue: false,
                information: information,
                hideBar: me.dashboardModel.hideBar
            };
        },

        showBarCharts: function () {
            const me = this;

            const percentBar = new App.views.ProgressBar({
                model: new Backbone.Model(me.getChartData())
            });

            me.charts.show(percentBar);
        }
    });

    const MetricPercentageWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: MetricPercentageView,
        processProps: function (props) {
            const me = this;

            props = widgets.Chart.buildMetrics(me, props);

            return props;
        },

        getDisplayValue: function (quotientMetric, divisorMetric) {
            const me = this;
            const quotientValue = quotientMetric.getValue({
                format: false
            });
            const divisorValue = divisorMetric.getValue({
                format: false
            });

            const percent = (quotientValue / divisorValue);
            const formatter = me.formatter || RivalIQ.formatter.formats.percentAbsolute;

            return (_.isFinite(percent) ? formatter(percent) : '--');
        },

        getPercentWidth: function (quotientMetric, divisorMetric) {
            const quotientValue = quotientMetric.getValue({
                format: false
            });
            const divisorValue = divisorMetric.getValue({
                format: false
            });

            if (_.isFinite(quotientValue) && _.isFinite(divisorValue) && divisorValue !== 0) {

                return Math.floor((quotientValue / divisorValue) * 100);
            } else {

                return (quotientValue > 0 ? 100 : 0);
            }
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.METRIC_PERCENTAGE, MetricPercentageWidget);

}, window.s, window.sprintf);
